import {createI18n} from 'vue-i18n'
import qs from "qs";
import {Locale} from "vant";
// import EN from './en/en'
// import CN from './ZH-CN/cn'

const message = {
    zh_CN: {
        updateTitle: '品牌升级公告',
        dearUser: '尊敬的A51用户：',
        updateContent: 'A51品牌已升级为PP88。原A51用户可直接登录PP88，资金和交易记录已迁移，不影响使用。如有疑问，请联系在线客服。',
        enterNow: '立即进入',
        knowDetail: '了解详细>>',
        appMore: 'APP体验更佳',
        downloadNow: '立即下载',
        team: 'PP88 团队',
        line: '线路 ',
        word1: '我们激动地宣布A51品牌已升级为{platform}',
        word2: '新变化包括：',
        word3: '全新品牌体验：提升程序流畅性和操作便利。',
        word4: '改善的会员福利：增加活动和优惠。',
        word5: '新增功能：提升用户体验。',
        word6: '原A51用户可直接用原账号登录PP88，所有资金和交易记录已安全迁移，无使用影响。如有疑问，请联系在线客服。',
        word7: '感谢您对PP88的支持与信任，我们期待在新平台上继续为您服务！',
    },
    en_US: {
        updateTitle: 'Brand Upgrade Announcement',
        dearUser: 'Dear A51 User:',
        updateContent: 'The A51 brand has been upgraded to PP88. Original A51 users can directly log in to PP88, with funds and transaction records migrated, without affecting usage. If you have any questions, please contact online customer service.',
        enterNow: 'Enter Now',
        knowDetail: 'Learn More >>',
        appMore: 'Better Experience with APP',
        downloadNow: 'Download Now',
        team: 'PP88 team',
        line: 'Route ',
        word1: 'We are excited to announce that \nthe A51 brand has been upgraded to {platform}',
        word2: 'The new changes include:',
        word3: 'Brand new brand experience: Enhancing program smoothness and operational convenience.',
        word4: 'Improved member benefits: Increase activities and offers.',
        word5: 'New features: Enhance user experience.',
        word6: 'Original A51 users can directly log in to PP88 with their existing accounts, all funds and transaction records have been safely migrated with no impact on usage. If you have any questions, please contact online customer service.',
        word7: 'Thank you for your support and trust in PP88, we look forward to continuing to serve you on the new platform!',
    },
    zh_TW: {
        updateTitle: '品牌升級公告',
        dearUser: '尊敬的A51用戶：',
        updateContent: 'A51品牌已升級為PP88。原A51用戶可直接登錄PP88，資金和交易記錄已遷移，不影響使用。如有疑問，請聯繫在線客服。',
        enterNow: '立即進入',
        knowDetail: '了解詳情>>',
        appMore: 'APP體驗更佳',
        downloadNow: '立即下載',
        team: 'PP88 團隊',
        line: '線路 ',
        word1: '我們興奮地宣布A51品牌已升級為{platform}',
        word2: '新變化包括：',
        word3: '全新品牌體驗：提升程序流暢性和操作便利。',
        word4: '改善的會員福利：增加活動和優惠。',
        word5: '新增功能：提升用戶體驗。',
        word6: '原A51用戶可直接用原賬號登錄PP88，所有資金和交易記錄已安全遷移，無使用影響。如有疑問，請聯繫在線客服。',
        word7: '感謝您對PP88的支持與信任，我們期待在新平台上繼續為您服務！'
    },
    en_MAS: {
        updateTitle: 'Pengumuman Penjenamaan Semula',
        dearUser: 'Pengguna Yang Dihormati A51:',
        updateContent: 'Jenama A51 telah dinaik taraf ke PP88. Pengguna asal A51 boleh log masuk terus ke PP88, dengan dana dan rekod transaksi yang dipindahkan, tanpa menjejaskan penggunaan. Jika ada pertanyaan, sila hubungi khidmat pelanggan atas talian.',
        enterNow: 'Masuk Sekarang',
        knowDetail: 'Ketahui Lebih Lanjut >>',
        appMore: 'Pengalaman Lebih Baik dengan APP',
        downloadNow: 'Muat Turun',
        team: 'pasukan PP88',
        line: 'Line  ',
        word1: 'Kami gembira mengumumkan bahawa \n jenama A51 telah dinaik taraf menjadi {platform}',
        word2: 'Perubahan baru termasuk:',
        word3: 'Pengalaman jenama yang baru: Peningkatan kelancaran program dan kemudahan operasi.',
        word4: 'Manfaat ahli yang diperbaiki: Peningkatan aktiviti dan tawaran.',
        word5: 'Ciri baru: Peningkatan pengalaman pengguna.',
        word6: 'Pengguna A51 asal boleh log masuk terus ke PP88 dengan akaun sedia ada, semua dana dan rekod transaksi telah dipindahkan dengan selamat tanpa impak pada penggunaan. Jika ada sebarang pertanyaan, sila hubungi khidmat pelanggan dalam talian.',
        word7: 'Terima kasih atas sokongan dan kepercayaan anda pada PP88, kami menantikan untuk terus berkhidmat kepada anda di platform baru!'
    },
    vi_VN: {
        updateTitle: 'Thông Báo Nâng Cấp Thương Hiệu',
        dearUser: 'Kính thưa Người Dùng A51:',
        updateContent: 'Thương hiệu A51 đã được nâng cấp thành PP88. Người dùng A51 gốc có thể trực tiếp đăng nhập vào PP88, với quỹ và hồ sơ giao dịch được chuyển giao, không ảnh hưởng đến việc sử dụng. Nếu có thắc mắc, xin vui lòng liên hệ dịch vụ khách hàng trực tuyến.',
        enterNow: 'Truy cập',
        knowDetail: 'Tìm Hiểu Thêm >>',
        appMore: 'Trải Nghiệm Tốt Hơn với Ứng Dụng',
        downloadNow: 'Tải xuống',
        team: 'đội PP88',
        line: 'Line ',
        word1: 'Chúng tôi phấn khích thông báo rằng \n thương hiệu A51 đã được nâng cấp thành {platform}',
        word2: 'Những thay đổi mới bao gồm:',
        word3: 'Trải nghiệm thương hiệu hoàn toàn mới: Nâng cao sự mượt mà của chương trình và tiện lợi trong thao tác.',
        word4: 'Lợi ích thành viên được cải thiện: Tăng cường các hoạt động và ưu đãi.',
        word5: 'Tính năng mới: Nâng cao trải nghiệm người dùng.',
        word6: 'Người dùng A51 gốc có thể đăng nhập trực tiếp vào PP88 với tài khoản hiện tại, tất cả tài chính và hồ sơ giao dịch đã được chuyển giao an toàn mà không ảnh hưởng đến việc sử dụng. Nếu có thắc mắc, vui lòng liên hệ dịch vụ khách hàng trực tuyến.',
        word7: 'Cảm ơn sự ủng hộ và tin tưởng của bạn đối với PP88, chúng tôi mong muốn tiếp tục phục vụ bạn trên nền tảng mới!'
    }
}

let parse = qs.parse(window.location.search.substring(1));
let lang = parse.lang;
if (!lang) {
    let locale = await getUserIP()
    let langMap = {
        "HK": 'zh_TW',
        "MS": 'en_MAS',
        "VN": 'vi_VN',
    }
    lang = langMap[locale]
}
if (!lang) {
    if (navigator.language === 'zh' || navigator.language === 'zh-CN' || navigator.language === 'zh-SG' || navigator.language === 'zh-MO' || navigator.language === 'zh-Hant') {
        lang = 'zh_CN';
    } else if (navigator.language === 'zh-HK' || navigator.language === 'zh-TW') {
        lang = 'zh_TW'
    } else if (navigator.language === 'ms' || navigator.language === 'mg' || navigator.language === 'ms-MY' || navigator.language === 'ms-BN') {
        lang = 'en_MAS'
    } else if (navigator.language === 'vi' || navigator.language === 'vi_VN') {
        lang = 'vi_VN'
    } else {
        lang = 'en_US';
    }
}

function textToJson(text) {
    const obj = {};
    const lines = text.split("\n");
    lines.forEach(line => {
        const [key, value] = line.split("=");
        obj[key] = value;
    });
    return obj;
}

async function getUserIP() {
    const response = await fetch('https://cloudflare.com/cdn-cgi/trace');
    const tmpData = await response.text();
    const data = textToJson(tmpData)
    console.log(data)
    return data.loc;
}

const i18n = createI18n({
    locale: lang, // 设置语言类型
    legacy: false, // 如果要支持compositionAPI，此项必须设置为false;
    globalInjection: true, // 全局注册$t方法
    messages: message,
})

const messages = {
    'zh-CN': {
        vanPicker: {
            confirm: '关闭', // 将'确认'修改为'关闭'
        },
    },
};

Locale.add(messages);

export default i18n
